module.exports = __webpack_public_path__ + "static/media/gray_13.3c40b224.jpg";